<template>
  <div class="keyboard-box">
    <div class="direction-box">
      <div class="up-box direction-item" @touchstart.stop.prevent="handleTouchstartItem('up')" @touchend.stop.prevent="handleTouchendItem('up')"></div>
      <div class="down-box direction-item" @touchstart.stop.prevent="handleTouchstartItem('down')" @touchend.stop.prevent="handleTouchendItem('down')"></div>
      <div class="left-box direction-item" @touchstart.stop.prevent="handleTouchstartItem('left')" @touchend.stop.prevent="handleTouchendItem('left')"></div>
      <div class="right-box direction-item" @touchstart.stop.prevent="handleTouchstartItem('right')" @touchend.stop.prevent="handleTouchendItem('right')"></div>
    </div>
    <div class="operation-box">
      <div class="affirm-btn confirm-box" @touchstart.stop.prevent="handleTouchstartItem('confirm')" @touchend.stop.prevent="handleTouchendItem('confirm')">

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "KeyboardBox",
    methods: {
      handleTouchstartItem(type){
        let box = document.querySelector(`.${type}-box`)
        box && (box.style.backgroundImage = `url("https://files.wondercv.com/Game/H5/${type}_press.png")`)
        this.$emit("on-keyboard", {type, keyType: "down"})
      },
      handleTouchendItem(type){
        let box = document.querySelector(`.${type}-box`)
        box && (box.style.backgroundImage = `url("https://files.wondercv.com/Game/H5/${type}_normal.png")`)
        this.$emit("on-keyboard", {type, keyType: "up"})
      }
    }
  }
</script>

<style scoped lang="scss">
.keyboard-box{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 32px;
  .direction-box{
    position: relative;
    width: 115px;
    height: 115px;
    .direction-item{
      position: absolute;
      width: 43px;
      height: 43px;
      background-size: 100%;
      background-repeat: no-repeat;
      border-radius: 50%;
    }
    .up-box{
      background-image: url("https://files.wondercv.com/Game/H5/up_normal.png");
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
    .down-box{
      background-image: url("https://files.wondercv.com/Game/H5/down_normal.png");
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
    .left-box{
      background-image: url("https://files.wondercv.com/Game/H5/left_normal.png");
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    .right-box{
      background-image: url("https://files.wondercv.com/Game/H5/right_normal.png");
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .operation-box{
    display: flex;
    padding-right: 30px;
    .affirm-btn{
      width: 82px;
      height: 82px;
      background-image: url("https://files.wondercv.com/Game/H5/confirm_normal.png");
      background-repeat: no-repeat;
      background-size: 100%;
    }
  }
}
</style>
